module.exports = __webpack_public_path__ + "img/aygaz-step-into-the-future-11.1ec5faca.jpg";